"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.StyledFormInput = exports.StyledAddressLegend = exports.Margin = exports.Flex = exports.Dropdown = exports.Container = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _FormInput = _interopRequireDefault(require("../../Components/Form/FormInput"));

var _Field = _interopRequireDefault(require("../../Components/Form/Field.styled"));

var _FormSelect = _interopRequireDefault(require("../../Components/Form/FormSelect"));

var _Form = require("../../Components/Form/Form.styled");

var _tokens = _interopRequireDefault(require("../../Tokens/tokens"));

var _utils = require("../../utils");

var _templateObject;

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var colors = _tokens.default.colors,
    font = _tokens.default.font;

var Flex = _styledComponents.default.div.withConfig({
  displayName: "Flex",
  componentId: "sc-1atef92-0"
})(["display:flex;flex-grow:1;flex-direction:", ";justify-content:", ";", ";", ";"], function (props) {
  return props.direction || "column";
}, function (props) {
  return props.justifyContent || "space-between";
}, function (props) {
  return props.responsive && (0, _styledComponents.css)(["margin-left:-", ";margin-right:-", ";> div{margin-left:", ";margin-right:", ";}", ";"], (0, _utils.pxToRem)(8), (0, _utils.pxToRem)(8), (0, _utils.pxToRem)(8), (0, _utils.pxToRem)(8), _utils.getBreakpoint.sm(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n            flex-direction: row;\n        "]))));
}, _styledSystem.layout);

exports.Flex = Flex;

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container",
  componentId: "sc-1atef92-1"
})(["width:100%;margin:0 auto auto;font-weight:", ";letter-spacing:normal;font-size:", ";color:", ";"], font.weight.book, font.size.base, colors.text.body);

exports.Container = Container;
var StyledFormInput = (0, _styledComponents.default)(_FormInput.default).withConfig({
  displayName: "StyledFormInput",
  componentId: "sc-1atef92-2"
})(["", "{max-width:100%;}"], _Field.default.Label);
exports.StyledFormInput = StyledFormInput;
var StyledAddressLegend = (0, _styledComponents.default)(_Form.FormLegendLabel).withConfig({
  displayName: "StyledAddressLegend",
  componentId: "sc-1atef92-3"
})(["margin-bottom:", ";"], (0, _utils.pxToRem)(24));
exports.StyledAddressLegend = StyledAddressLegend;

var Margin = _styledComponents.default.div.withConfig({
  displayName: "Margin",
  componentId: "sc-1atef92-4"
})(["margin-top:", ";margin-right:", ";margin-bottom:", ";margin-left:", ";"], function (props) {
  return props.top + "rem" || "0";
}, function (props) {
  return props.right + "rem" || "0";
}, function (props) {
  return props.bottom + "rem" || "0";
}, function (props) {
  return props.left + "rem" || "0";
});

exports.Margin = Margin;
Margin.propTypes = {
  top: _propTypes.default.number,
  bottom: _propTypes.default.number,
  left: _propTypes.default.number,
  right: _propTypes.default.number
};

var Dropdown = function Dropdown(props) {
  return /*#__PURE__*/_react.default.createElement(_FormSelect.default, props);
};

exports.Dropdown = Dropdown;
Dropdown.defaultProps = {
  errorMessage: "This field is required."
};
Dropdown.propTypes = Object.assign({}, _FormSelect.default.propTypes, {
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  options: _propTypes.default.array.isRequired,
  value: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
});